import { RxStompConfig } from '@stomp/rx-stomp';
import { RxStompService } from './rx-stomp.service';

export function RxStompServiceFactory(config: RxStompConfig) {
  const rxStomp = new RxStompService();
  rxStomp.configure(config);
  rxStomp.activate();
  return rxStomp;
}
